import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import HistoryIcon from "../../../Custom-imeges/HistoryIcon";
import "../View/SuiteHistory.css";

interface HistoryButtonProps {
  navigateRoute: string;
}
export const HistoryButton = ({ navigateRoute }: HistoryButtonProps) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(navigateRoute);
  };

  return (
    <Box
      className="history-btn-container"
      onClick={handleNavigate}
    >
      <HistoryIcon className="history-btn-icn" />
      <Typography className="history-btn-title">History</Typography>
    </Box>
  );
};
